var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "members-preview",
      class: { "members-preview_loading": _vm.loading },
    },
    [
      _c("div", { staticClass: "members-preview__header" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "members-preview__previews-container" },
        [
          _vm._l(_vm.members, function (user) {
            return _c(
              "span",
              { key: user.id },
              [
                _vm.useSimpleLink
                  ? _c(
                      "a",
                      {
                        staticStyle: { "text-decoration": "none" },
                        attrs: {
                          href: user.link,
                          tabindex: "-1",
                          "aria-label": user.name,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: user.name,
                                expression: "user.name",
                              },
                            ],
                            staticClass: "member-preview",
                            style: _vm.getAvatarStyle(user),
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            user.online
                              ? _c("div", {
                                  staticClass: "member-preview__online_mark",
                                })
                              : _vm._e(),
                          ]
                        ),
                      ]
                    )
                  : _c(
                      "router-link",
                      {
                        staticStyle: { "text-decoration": "none" },
                        attrs: {
                          to: user.link,
                          tabindex: "-1",
                          "aria-label": user.name,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: user.name,
                                expression: "user.name",
                              },
                            ],
                            staticClass: "member-preview",
                            style: _vm.getAvatarStyle(user),
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            user.online
                              ? _c("div", {
                                  staticClass: "member-preview__online_mark",
                                })
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.loading
            ? _c("i", {
                staticClass:
                  "fas fa-circle-notch fa-spin members-preview__loading-mark",
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.membersLink
        ? _c(
            "div",
            {
              staticClass: "members-preview__see-all",
              class: {
                "members-preview__see-all_active": _vm.seeAllLinkHighlighted,
              },
            },
            [
              _c(
                "router-link",
                { attrs: { to: _vm.membersLink, tabindex: "-1" } },
                [_vm._v(_vm._s(_vm.seeAllText) + "\n        ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }